import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-6 error--text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_combobox = _resolveComponent("v-combobox")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          class: "input-label",
          style: _normalizeStyle({ paddingLeft: Object.keys(_ctx.$attrs).includes('prepend-icon') ? '42px' : '0px' })
        }, [
          _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
          (_ctx.showRequired)
            ? (_openBlock(), _createElementBlock("small", _hoisted_1, "*"))
            : _createCommentVNode("", true)
        ], 4))
      : _createCommentVNode("", true),
    _createVNode(_component_v_combobox, _mergeProps({ "menu-props": { scrollStrategy: 'close' } }, _ctx.$attrs, {
      attach: "",
      "model-value": _ctx.modelValue,
      "onUpdate:modelValue": _ctx.valueChanged,
      onBlur: _ctx.blur
    }), _createSlots({ _: 2 }, [
      (_ctx.firstInactiveId)
        ? {
            name: "item",
            fn: _withCtx(({ item, props }) => [
              _createVNode(_component_v_list, { class: "pa-0" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item, _mergeProps(props, {
                    class: { 'txt-color': _ctx.firstInactiveId && _ctx.firstInactiveId === item.props.value },
                    title: item.props.title
                  }), null, 16, ["class", "title"])
                ]),
                _: 2
              }, 1024)
            ]),
            key: "0"
          }
        : undefined
    ]), 1040, ["model-value", "onUpdate:modelValue", "onBlur"])
  ]))
}